import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Img = styled.img`
  height: 50px;
  max-width: 50px
  width: auto;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  &:not(:last-child) {
    margin-right: 5px;
  }
`

const Image = ({ src }) => {
    const download = () => {
        const downloadTag = document.createElement('a')
        downloadTag.href = src
        downloadTag.target = '_blank'
        downloadTag.click()
    }

    return <Img src={src} alt="" onClick={download} />
}

Image.propTypes = {
    src: PropTypes.string,
}

Image.defaultProps = {
    src: '',
}

export default Image
